export function applyCustomFont(site) {
  const fontFamily = site?.custom_font_details?.family;
  if (!fontFamily || !site?.use_custom_font) return () => {};

  const formattedFamily = fontFamily.replace(/ /g, "+");
  const fontLink = `https://fonts.googleapis.com/css2?family=${formattedFamily}&display=swap`;

  if (!document.querySelector(`link[href="${fontLink}"]`)) {
    const link = document.createElement("link");
    link.href = fontLink;
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }

  document.body.style.fontFamily = `'${fontFamily}', ${site?.custom_font_details?.category || "sans-serif"}`;

  // Cleanup function
  return () => {
    const existingLink = document.querySelector(`link[href="${fontLink}"]`);
    if (existingLink) existingLink.remove();
    document.body.style.fontFamily = "";
  };
}

export function applyGlobalHtml(global_html) {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = global_html;

  Array.from(tempDiv.childNodes).forEach((node) => {
    if (node.tagName === "SCRIPT") {
      const script = document.createElement("script");

      for (let attr of node.attributes) {
        script.setAttribute(attr.name, attr.value);
      }

      if (node.textContent) {
        script.textContent = node.textContent;
      }

      document.body.appendChild(script);
    } else {
      document.body.appendChild(node);
    }
  });
}
